import {ReactNode} from 'react';

import {Box, Typography} from '@mui/material';

import {greenColors, neutral} from '../../../../../layouts/theme/designSystem';

export interface Props {
  title: string;
  helper?: string;
  children: ReactNode;
}

export const TargetProfileDialogSectionCard = ({title, helper, children}: Props) => {
  return (
    <Box
      sx={{
        border: `1px solid ${neutral[200]}`,
        borderRadius: '12px',
        bgcolor: 'background.paper',
        px: {xs: 2, sm: 2.5},
        py: {xs: 1.75, sm: 2},
        mb: 2,
      }}
    >
      <Typography variant='h3' sx={{color: greenColors[900], mb: helper ? 0.5 : 1.25}}>
        {title}
      </Typography>
      {helper && (
        <Typography variant='body2' color='text.secondary' sx={{mb: 1.5}}>
          {helper}
        </Typography>
      )}
      {children}
    </Box>
  );
};
